export function GetData(type, token) {
    return new Promise((resolve, reject) => {
        const requestOptions = {
            method: 'GET',
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': 'POST',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
        };
        fetch("https://test.mokhasangham.com/api/" + type, requestOptions)
            .then((response) => response.json())
            .then((responseJSON) => {
                resolve(responseJSON)
            })
            .catch((error) => {
                reject(error)
            })
    })
}